import { render } from "./Purchases.vue?vue&type=template&id=14c90f5a&scoped=true"
import script from "./Purchases.vue?vue&type=script&lang=js"
export * from "./Purchases.vue?vue&type=script&lang=js"

import "./Purchases.vue?vue&type=style&index=0&id=14c90f5a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c90f5a"]])

export default __exports__